import apiClient from '@/api/client';
import { SIMILARITY } from '@/api/endpoints';
import type { PaginatedResponse } from '@/api/types/common.types';
import type {
  SimilarityGroup,
  SimilarityGroupDetail,
  SimilarityGroupFilters,
  SimilarityGroupUpdatePayload,
  SimilarityRunPayload,
  SimilarityRunResponse,
} from '@/api/types/similarity.types';

// ---------------------------------------------------------------------------
// List & Detail
// ---------------------------------------------------------------------------

/**
 * Fetch similarity groups for an event.
 */
export async function getSimilarityGroups(
  params?: SimilarityGroupFilters,
): Promise<PaginatedResponse<SimilarityGroup>> {
  const { data } = await apiClient.get<PaginatedResponse<SimilarityGroup>>(
    SIMILARITY.GROUPS,
    { params },
  );
  return data;
}

/**
 * Fetch a single similarity group with all its photos.
 */
export async function getSimilarityGroup(
  groupId: string,
): Promise<SimilarityGroupDetail> {
  const { data } = await apiClient.get<SimilarityGroupDetail>(
    SIMILARITY.GROUP_DETAIL(groupId),
  );
  return data;
}

// ---------------------------------------------------------------------------
// Mutations
// ---------------------------------------------------------------------------

/**
 * Override the best photo in a similarity group.
 */
export async function updateSimilarityGroupBestPhoto(
  groupId: string,
  payload: SimilarityGroupUpdatePayload,
): Promise<SimilarityGroupDetail> {
  const { data } = await apiClient.patch<SimilarityGroupDetail>(
    SIMILARITY.GROUP_UPDATE(groupId),
    payload,
  );
  return data;
}

/**
 * Manually trigger similarity computation for an event.
 */
export async function runSimilarity(
  payload: SimilarityRunPayload,
): Promise<SimilarityRunResponse> {
  const { data } = await apiClient.post<SimilarityRunResponse>(
    SIMILARITY.RUN,
    payload,
  );
  return data;
}
